export default __webpack_public_path__ + "static/media/UA.f4e5609d.svg";